import { ChangeEvent, KeyboardEvent, useState } from 'react';

import { TextField } from '@braskai/ui-kit';

import { CREDIT_MAX_VALUE, CREDIT_MIN_VALUE, INPUT_SETTINGS, SLIDER_MARKS } from '../../lib/constants';
import { Benefits } from '../Benefits';
import {
  Container,
  Label,
  Price,
  PriceContainer,
  Slider,
  SliderContainer,
  TotalAndPriceContainer,
  TotalContainer,
} from './styled';

type CreditSliderProps = {
  pricePerMin: number;
  onChange: (newPrice: number | number[]) => void;
};

export const CreditSlider = ({ pricePerMin, onChange }: CreditSliderProps) => {
  const [value, setValue] = useState<number>(CREDIT_MIN_VALUE);

  /**  MUI Slider требует указать тип number | number[] */
  const handleSliderChange = (_: Event, newValue: number | number[]) => {
    setValue(newValue as number);
    onChange(newValue);
  };

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const inputValue = event.target.value;
    const positiveValue = Math.abs(Number(inputValue.replace(/\D/g, '')));

    /** Для предотвращения ввода 012  */
    // eslint-disable-next-line no-param-reassign
    event.target.value = String(positiveValue);

    if (Number(positiveValue) <= CREDIT_MAX_VALUE) {
      setValue(inputValue === '' ? 0 : positiveValue);
      onChange(Number(positiveValue));
      return;
    }

    if (Number(positiveValue) > CREDIT_MAX_VALUE) {
      setValue(CREDIT_MAX_VALUE);
      onChange(CREDIT_MAX_VALUE);
      return;
    }

    setValue(CREDIT_MIN_VALUE);
    onChange(CREDIT_MIN_VALUE);
  };

  const handleBlur = () => {
    if (Number(value) < CREDIT_MIN_VALUE) {
      setValue(0);
    } else if (Number(value) > CREDIT_MAX_VALUE) {
      setValue(CREDIT_MAX_VALUE);
    }
  };

  const handleCreditInputKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    const restrictedKeys = /^[+,e-]$/;
    if (restrictedKeys.test(event.key)) {
      event.preventDefault();
    }
  };

  return (
    <Container>
      <SliderContainer>
        <Slider
          marks={SLIDER_MARKS}
          max={CREDIT_MAX_VALUE}
          min={CREDIT_MIN_VALUE}
          value={value}
          onChange={handleSliderChange}
        />
      </SliderContainer>

      <TotalAndPriceContainer>
        <TotalContainer>
          <Label>Minutes</Label>
          <TextField
            slotProps={{
              input: {
                inputProps: INPUT_SETTINGS,
              },
            }}
            data-testid="buy-minutes-modal-minutes-input"
            value={value}
            variant="outlined"
            fullWidth
            onBlur={handleBlur}
            onChange={handleInputChange}
            onKeyDown={handleCreditInputKeyDown}
          />
        </TotalContainer>

        <PriceContainer>
          <Label>Price</Label>
          <Price>${pricePerMin}/min</Price>
        </PriceContainer>
      </TotalAndPriceContainer>

      <Benefits />
    </Container>
  );
};
